import React, { useMemo, useState, useEffect, useCallback, useRef } from "react";
import {
  DataGrid,
  esES,
  GridActionsCellItem
} from "@mui/x-data-grid";
import {
  Button,
  Stack,
  Snackbar,
  Alert
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DownloadIcon from "@mui/icons-material/Download";
import CompanyThemeProvider from "./company_theme_provider";
import { brandColors } from "../lib/pop_design_system";

const monthColumns = [
  { field: "january_amount", label: "Enero" },
  { field: "february_amount", label: "Febrero" },
  { field: "march_amount", label: "Marzo" },
  { field: "april_amount", label: "Abril" },
  { field: "may_amount", label: "Mayo" },
  { field: "june_amount", label: "Junio" },
  { field: "july_amount", label: "Julio" },
  { field: "august_amount", label: "Agosto" },
  { field: "september_amount", label: "Septiembre" },
  { field: "october_amount", label: "Octubre" },
  { field: "november_amount", label: "Noviembre" },
  { field: "december_amount", label: "Diciembre" },
];

const COMMUNE_OPTIONS = [
  "ARICA","CAMARONES","IQUIQUE","PICA","POZO ALMONTE","HUARA","CAMINA","COLCHANE","ALTO HOSPICIO","PUTRE","GENERAL LAGOS","TOCOPILLA","MARIA ELENA","ANTOFAGASTA","TALTAL","MEJILLONES","SIERRA GORDA","CALAMA","OLLAGUE","SAN PEDRO DE ATACAMA","CHANARAL","DIEGO DE ALMAGRO","COPIAPO","CALDERA","TIERRA AMARILLA","VALLENAR","FREIRINA","HUASCO","ALTO DEL CARMEN","LA SERENA","LA HIGUERA","COQUIMBO","ANDACOLLO","VICUNA","PAIHUANO","OVALLE","MONTE PATRIA","PUNITAQUI","COMBARBALA","RIO HURTADO","ILLAPEL","SALAMANCA","LOS VILOS","CANELA","ISLA DE PASCUA","LA LIGUA","PETORCA","CABILDO","ZAPALLAR","PAPUDO","VALPARAISO","VINA DEL MAR","VILLA ALEMANA","QUILPUE","CASABLANCA","QUINTERO","PUCHUNCAVI","JUAN FERNANDEZ","CONCON","SAN ANTONIO","SANTO DOMINGO","CARTAGENA","EL TABO","EL QUISCO","ALGARROBO","QUILLOTA","NOGALES","HIJUELAS","LA CALERA","LA CRUZ","LIMACHE","OLMUE","SAN FELIPE","PANQUEHUE","CATEMU","PUTAENDO","SANTA MARIA","LLAY-LLAY","LOS ANDES","CALLE LARGA","SAN ESTEBAN","RINCONADA","RANCAGUA","MACHALI","GRANEROS","SAN FRANCISCO DE MOSTAZAL","DONIHUE","COLTAUCO","CODEGUA","PEUMO","LAS CABRAS","SAN VICENTE","PICHIDEGUA","RENGO","REQUINOA","OLIVAR","MALLOA","COINCO","QUINTA DE TILCOCO","SAN FERNANDO","CHIMBARONGO","NANCAGUA","PLACILLA","SANTA CRUZ","LOLOL","PALMILLA","PERALILLO","CHEPICA","PUMANQUE","PICHILEMU","NAVIDAD","LITUECHE","LA ESTRELLA","MARCHIGUE","PAREDONES","CURICO","TENO","ROMERAL","RAUCO","LICANTEN","VICHUQUEN","HUALANE","MOLINA","SAGRADA FAMILIA","TALCA","SAN CLEMENTE","PELARCO","RIO CLARO","PENCAHUE","MAULE","CUREPTO","CONSTITUCION","EMPEDRADO","SAN RAFAEL","LINARES","YERBAS BUENAS","COLBUN","LONGAVI","PARRAL","RETIRO","VILLA ALEGRE","SAN JAVIER","CAUQUENES","PELLUHUE","CHANCO","CHILLAN","PINTO","COIHUECO","QUIRIHUE","NINHUE","PORTEZUELO","COBQUECURA","TREHUACO","SAN CARLOS","NIQUEN","SAN FABIAN","SAN NICOLAS","BULNES","SAN IGNACIO","QUILLON","YUNGAY","PEMUCO","EL CARMEN","RANQUIL","COELEMU","CHILLAN VIEJO","CONCEPCION","PENCO","HUALQUI","FLORIDA","TOME","TALCAHUANO","CORONEL","LOTA","SANTA JUANA","SAN PEDRO DE LA PAZ","CHIGUAYANTE","HUALPEN","ARAUCO","CURANILAHUE","LEBU","LOS ALAMOS","CANETE","CONTULMO","TIRUA","LOS ANGELES","SANTA BARBARA","LAJA","QUILLECO","NACIMIENTO","NEGRETE","MULCHEN","QUILACO","YUMBEL","CABRERO","SAN ROSENDO","TUCAPEL","ANTUCO","ALTO BIOBIO","ANGOL","PUREN","LOS SAUCES","RENAICO","COLLIPULLI","ERCILLA","TRAIGUEN","LUMACO","VICTORIA","CURACAUTIN","LONQUIMAY","TEMUCO","VILCUN","FREIRE","CUNCO","LAUTARO","PERQUENCO","GALVARINO","NUEVA IMPERIAL","CARAHUE","SAAVEDRA","PITRUFQUEN","GORBEA","TOLTEN","LONCOCHE","VILLARRICA","PUCON","MELIPEUCO","CURARREHUE","TEODORO SCHMIDT","PADRE LAS CASAS","CHOLCHOL","VALDIVIA","MARIQUINA","LANCO","LOS LAGOS","FUTRONO","CORRAL","MAFIL","PANGUIPULLI","LA UNION","PAILLACO","RIO BUENO","LAGO RANCO","OSORNO","SAN PABLO","PUERTO OCTAY","PUYEHUE","RIO NEGRO","PURRANQUE","SAN JUAN DE LA COSTA","PUERTO MONTT","COCHAMO","PUERTO VARAS","FRESIA","FRUTILLAR","LLANQUIHUE","MAULLIN","LOS MUERMOS","CALBUCO","CASTRO","CHONCHI","QUEILEN","QUELLON","PUQUELDON","ANCUD","QUEMCHI","DALCAHUE","CURACO DE VELEZ","QUINCHAO","CHAITEN","HUALAIHUE","FUTALEUFU","PALENA","AYSEN","CISNES","GUAITECAS","CHILE CHICO","RIO IBANEZ","COCHRANE","OHIGGINS","TORTEL","COYHAIQUE","LAGO VERDE","NATALES","TORRES DEL PAINE","RIO VERDE","SAN GREGORIO","PUNTA ARENAS","LAGUNA BLANCA","PORVENIR","PRIMAVERA","TIMAUKEL","CABO DE HORNOS","SANTIAGO","SANTIAGO OESTE","SANTIAGO SUR","RECOLETA","INDEPENDENCIA","QUINTA NORMAL","MAIPU","PUDAHUEL","RENCA","QUILICURA","CONCHALI","LO PRADO","CERRO NAVIA","ESTACION CENTRAL","HUECHURABA","CERRILLOS","COLINA","LAMPA","TIL-TIL","TALAGANTE","ISLA DE MAIPO","EL MONTE","PENAFLOR","PADRE HURTADO","MELIPILLA","MARIA PINTO","CURACAVI","SAN PEDRO","ALHUE","PROVIDENCIA","NUNOA","LAS CONDES","LA FLORIDA","LA REINA","MACUL","PENALOLEN","VITACURA","LO BARNECHEA","SAN MIGUEL","LA CISTERNA","LA GRANJA","SAN RAMON","LA PINTANA","PEDRO AGUIRRE CERDA","SAN JOAQUIN","LO ESPEJO","EL BOSQUE","PUENTE ALTO","PIRQUE","SAN JOSE DE MAIPO","SAN BERNARDO","CALERA DE TANGO","BUIN","PAINE"]

const baseColumns = [
  {
    field: "administration",
    headerName: "Administración",
    width: 150,
    type: "boolean",
    editable: true
  },
  { field: "role_block", headerName: "Rol Manzana", width: 110, editable: true },
  { field: "role_property", headerName: "Rol Propiedad", width: 120, editable: true },
  {
    field: "commune",
    headerName: "Comuna",
    width: 200,
    editable: true,
    renderEditCell: (params) => (
      <div style={{ width: "100%" }}>
        <Autocomplete
          fullWidth
          options={COMMUNE_OPTIONS}
          value={params.value || ""}
          onChange={(event, newValue) => {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue || "" }, event);
            params.api.stopCellEditMode({ id: params.id, field: params.field });
          }}
          renderInput={(props) => (
            <TextField
              {...props}
              size="small"
              variant="standard"
              autoFocus
              fullWidth
            />
          )}
        />
      </div>
    )
  },
  { field: "lessor_rut", headerName: "RUT Arrendador", width: 140, editable: true },
  { field: "lessor_rut_code", headerName: "DV Arrendador", width: 120, editable: true },
  { field: "tenant_rut", headerName: "RUT Arrendatario", width: 140, editable: true },
  { field: "tenant_rut_code", headerName: "DV Arrendatario", width: 120, editable: true },
];

const purposeOptions = [
  { value: "", label: "Sin dato" },
  { value: "1", label: "Habitacional" },
  { value: "2", label: "Comercial" },
  { value: "3", label: "Estacionamiento" },
  { value: "4", label: "Bodega" },
  { value: "5", label: "Mixto" },
  { value: "6", label: "Otro" }
];

const natureOptions = [
  { value: "", label: "Sin dato" },
  { value: "1", label: "Agrícola" },
  { value: "2", label: "No Agrícola" }
];

const furnishedOptions = [
  { value: "", label: "Sin dato" },
  { value: "2", label: "Sí" },
  { value: "1", label: "No" }
];

const tailColumns = [
  {
    field: "furnished",
    headerName: "Amoblado",
    width: 120,
    type: "singleSelect",
    editable: true,
    valueOptions: furnishedOptions,
    valueFormatter: ({ value }) => (value === "2" ? "Sí" : value === "1" ? "No" : "Sin dato"),
  },
  {
    field: "purpose",
    headerName: "Destino",
    width: 140,
    type: "singleSelect",
    editable: true,
    valueOptions: purposeOptions,
    valueFormatter: ({ value }) => {
      const match = purposeOptions.find((option) => option.value === (value ?? ""));
      return match ? match.label : value;
    },
  },
  {
    field: "dfl2",
    headerName: "DFL2",
    width: 100,
    type: "singleSelect",
    editable: true,
    valueOptions: [
      { value: "X", label: "Sí" },
      { value: "NO", label: "No" }
    ],
    valueFormatter: ({ value }) => (value === "X" ? "Sí" : "No"),
  },
  {
    field: "nature",
    headerName: "Naturaleza",
    width: 140,
    type: "singleSelect",
    editable: true,
    valueOptions: natureOptions,
    valueFormatter: ({ value }) => {
      const match = natureOptions.find((option) => option.value === (value ?? ""));
      return match ? match.label : value;
    },
  },
];

const numericColumn = (field, headerName) => ({
  field,
  headerName,
  width: 110,
  align: "right",
  headerAlign: "right",
  type: "number",
  editable: true,
  valueGetter: ({ value }) => (value === null || value === undefined ? null : Number(value)),
  valueFormatter: ({ value }) =>
    value === null || value === undefined ? "" : new Intl.NumberFormat("es-CL").format(value),
  valueParser: (value) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const normalized = String(value).replace(",", ".");
    const number = Number(normalized);
    return Number.isNaN(number) ? null : number;
  },
});

const monthFields = monthColumns.map(({ field }) => field);
const numericFields = new Set(monthFields);

const normalizeRow = (row) => {
  const normalized = { ...row };
  normalized.id = row.id;
  normalized.rent_id = row.rent_id;
  monthFields.forEach((field) => {
    normalized[field] =
      row[field] === null || row[field] === undefined ? null : Number(row[field]);
  });
  normalized.furnished = row.furnished ? String(row.furnished) : "";
  normalized.purpose = row.purpose ? String(row.purpose) : "";
  normalized.nature = row.nature ? String(row.nature) : "";
  normalized.dfl2 = row.dfl2 === "X" ? "X" : "NO";
  normalized.administration =
    row.administration === undefined || row.administration === null ? true : Boolean(row.administration);
  return normalized;
};

const normalizeRows = (rows) => rows.map((row) => normalizeRow(row));

const nilIfNo = (value) => (value === "NO" ? null : value);

const prepareValueForServer = (field, value) => {
  if (value === undefined) return null;
  if (value === "" || value === null) return null;
  if (field === "administration") {
    return Boolean(value);
  }
  if (field === "dfl2") {
    return value === "X" ? "X" : nilIfNo(value);
  }
  if (field === "furnished" || field === "purpose" || field === "nature") {
    return value;
  }
  if (numericFields.has(field)) {
    const numericValue = typeof value === "number" ? value : Number(String(value).replace(",", "."));
    return Number.isNaN(numericValue) ? null : numericValue;
  }
  return value;
};

const Dj1835DetailsTable = ({ rows = [], year, paths = {} }) => {
  const [rowsState, setRowsState] = useState(() => normalizeRows(rows));
  const [pathsState, setPathsState] = useState(paths);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const rowsRef = useRef(rowsState);
  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";

  useEffect(() => {
    setRowsState(normalizeRows(rows));
  }, [rows]);

  useEffect(() => {
    setPathsState(paths);
  }, [paths]);

  useEffect(() => {
    rowsRef.current = rowsState;
  }, [rowsState]);

  const request = useCallback(
    async (url, options = {}) => {
      const defaultOptions = {
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        }
      };
      const response = await fetch(url, { ...defaultOptions, ...options });
      if (!response.ok) {
        let message = "Ocurrió un error inesperado.";
        try {
          const payload = await response.json();
          if (payload?.error) {
            message = payload.error;
          }
        } catch (e) {
          // ignore
        }
        throw new Error(message);
      }
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        return response.json();
      }
      return response.text();
    },
    [csrfToken]
  );

  const handleCreateDetail = useCallback(async () => {
    if (!pathsState.create_detail) return;
    try {
      setLoading(true);
      const data = await request(pathsState.create_detail, {
        method: "POST",
        body: JSON.stringify({ dj1835_file_detail: {} })
      });
      const newRow = normalizeRow(data.row);
      setRowsState((prev) => [newRow, ...prev]);
      setSuccess("Detalle creado correctamente.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [pathsState.create_detail, request]);

  const handleDeleteDetail = useCallback(
    async (id) => {
      if (!pathsState.destroy_detail) return;
      const confirmed = window.confirm("¿Seguro deseas eliminar este detalle?");
      if (!confirmed) return;
      try {
        setLoading(true);
      const url = pathsState.destroy_detail.replace("__ID__", id);
        await request(url, { method: "DELETE" });
        setRowsState((prev) => prev.filter((row) => row.id !== id));
        setSuccess("Detalle eliminado.");
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    },
    [pathsState.destroy_detail, request]
  );

  const editableFields = useMemo(
    () => [
      ...baseColumns.map((column) => column.field),
      ...monthColumns.map(({ field }) => field),
      ...tailColumns.map((column) => column.field)
    ],
    []
  );

  const handleProcessRowUpdate = useCallback(
    async (newRow, oldRow) => {
      if (!pathsState.update_detail) return oldRow;
      const changes = {};
      editableFields.forEach((field) => {
        if (newRow[field] !== oldRow[field]) {
          changes[field] = prepareValueForServer(field, newRow[field]);
        }
      });
      if (Object.keys(changes).length === 0) {
        return oldRow;
      }
      try {
        setLoading(true);
        const url = pathsState.update_detail.replace("__ID__", newRow.id);
        const data = await request(url, {
          method: "PATCH",
          body: JSON.stringify({ dj1835_file_detail: changes })
        });
        const updatedRow = normalizeRow(data.row);
        setRowsState((prev) =>
          prev.map((row) => (row.id === updatedRow.id ? updatedRow : row))
        );
        setSuccess("Detalle actualizado.");
        return updatedRow;
      } catch (err) {
        setError(err.message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [editableFields, pathsState.update_detail, request]
  );

  const handleProcessRowUpdateError = useCallback((err) => {
    setError(err?.message || "No fue posible guardar los cambios.");
  }, []);

  const handleRebuild = useCallback(async () => {
    if (!pathsState.rebuild) return;
    const confirmed = window.confirm(
      "Esto eliminará el archivo y lo reconstruirá nuevamente con los datos actuales. ¿Deseas continuar?"
    );
    if (!confirmed) return;
    try {
      setLoading(true);
      const data = await request(pathsState.rebuild, {
        method: "POST",
        body: JSON.stringify({})
      });
      setRowsState(normalizeRows(data.rows || []));
      setPathsState(data.paths || pathsState);
      setSuccess("Archivo reconstruido correctamente.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [pathsState, request]);

  const handleDownload = useCallback(async () => {
    if (!pathsState.download) return;
    try {
      setLoading(true);
      const response = await fetch(pathsState.download, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-CSRF-Token": csrfToken
        }
      });
      if (!response.ok) {
        throw new Error("No fue posible descargar el archivo.");
      }
      const blob = await response.blob();
      let filename = `dj1835-${year}.csv`;
      const disposition = response.headers.get("Content-Disposition");
      if (disposition) {
        const match = disposition.match(/filename=\"?([^\";]+)\"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setSuccess("Descarga iniciada.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [pathsState.download, csrfToken, year]);

  const columns = useMemo(() => {
    const rentColumn = {
      field: "rent_id",
      headerName: "Arriendo",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (!params.value) return "-";
        const url = `/staff/rents/${params.value}`;
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="dj1835-rent-link"
          >
            #{params.value}
          </a>
        );
      }
    };

    const base = baseColumns.map((column) => ({
      ...column,
      editable: true
    }));
    const months = monthColumns.map(({ field, label }) => numericColumn(field, label));
    const tail = tailColumns.map((column) => ({
      ...column
    }));
    const actions = {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 60,
      getActions: ({ id }) => [
        <GridActionsCellItem
          key="delete"
          icon={<DeleteOutlineIcon fontSize="small" />}
          label="Eliminar"
          onClick={() => handleDeleteDetail(id)}
          showInMenu={false}
        />
      ]
    };

    return [rentColumn, ...base, ...months, ...tail, actions];
  }, [handleDeleteDetail]);

  return (
    <CompanyThemeProvider>
      <div className="dj1835-datagrid-wrapper">
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-start"
          alignItems="center"
          className="dj1835-actions"
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleCreateDetail}
            disabled={loading}
          >
            Agregar fila
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<AutorenewIcon />}
            onClick={handleRebuild}
            disabled={loading}
          >
            Reconstruir
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Descargar CSV
          </Button>
          <span className="dj1835-year-indicator">
            Año en visualización: <strong>{year}</strong>
          </span>
        </Stack>
        <DataGrid
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          rows={rowsState}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
          pageSizeOptions={[25, 50, 100]}
          density="compact"
          columnBuffer={2}
          disableRowSelectionOnClick
          processRowUpdate={handleProcessRowUpdate}
          onProcessRowUpdateError={handleProcessRowUpdateError}
          sx={{
            borderColor: brandColors?.primary?.light || "rgba(224, 224, 224, 1)",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: brandColors?.primary?.light || "rgba(241, 245, 249, 1)",
              color: brandColors?.primary?.contrastText || "#ffffff",
              fontWeight: 700,
              fontSize: "14px",
              lineHeight: "32px",
              "& .MuiDataGrid-columnHeader": {
                paddingLeft: "6px",
                paddingRight: "6px",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 700,
              },
            },
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              paddingLeft: "6px",
              paddingRight: "6px",
            },
            "& .MuiTablePagination-root": {
              fontSize: "14px",
              paddingLeft: "8px",
              paddingRight: "8px",
              "& .MuiTablePagination-selectLabel": {
                fontSize: "14px",
              },
              "& .MuiTablePagination-displayedRows": {
                fontSize: "14px",
              },
              "& .MuiTablePagination-input": {
                fontSize: "14px",
              },
              "& .MuiSelect-select": {
                fontSize: "14px !important",
                paddingRight: "18px !important",
              },
              "& .MuiSvgIcon-root": {
                fontSize: "20px",
              },
              "& .MuiIconButton-root": {
                padding: "6px",
              },
            },
            "& .MuiDataGrid-toolbarContainer": {
              fontSize: "14px",
            },
          }}
        />
      </div>
      <Snackbar
        open={Boolean(error)}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setError(null)} severity="error" variant="filled">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(success)}
        autoHideDuration={4000}
        onClose={() => setSuccess(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setSuccess(null)} severity="success" variant="filled">
          {success}
        </Alert>
      </Snackbar>
    </CompanyThemeProvider>
  );
};

export default Dj1835DetailsTable;
